import { useEffect, useState, useRef } from "react"
import { io } from "socket.io-client"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import { StaticElevationSvgJsx } from "../ApartmentFinder/Components/SvgJSX"
import {
  useBlockIDbyPlotNumber,
  useApartmentFloorLevelByPlotNumber,
  useApartmentTypeByPlotNumber
} from "../ApartmentFinder/Utils/hooks"
import {
  FavouriteCardContainer,
  FloorplanHolder,
  InfoHolder,
  TitleHolder,
  ElevationHolder,
  Level,
  Button,
  ApartID,
  ButtonHolder,
  Content,
  BlockID,
  InfoContent,
  Dimensions,
  Compas,
  BookmarkHolder,
  ThreeSixtyWrapper
} from "./FavouriteCard.style"
import FavouriteBookmark from "../../ApartmentFinderConfig/Icons/FavouriteBookmark"
import Viewer360 from "../Viewer360"
import { zeroPad } from "../../utils/utils"
import { useStore } from "../../state/store"
import { blockFViewMapper } from "../../ApartmentFinderConfig/blockFViewMapper"
import { dimsdata } from "./dimsData"

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE
export const buildingNames = {
  E1: "Manuscript Court",
  K1: "Fold House",
  F1: "Dispatch House",
  F2: "Opus House"
}

export default function FavouriteCard({ id, isFromFavourites = false }) {
  const [visible, setVisible] = useState(false)
  let data
  id = Number(id)

  let activeApt = useBlockIDbyPlotNumber()[id]
  const isMultiView = typeof blockFViewMapper[activeApt] === "object"

  console.log("isMultiView", isMultiView)

  const viewID = useStore(state => state.viewID)
  const setViewID = useStore(state => state.setViewID)
  const setFullScreenPlan = useStore(state => state.setFullScreenPlan)
  const favourites = useStore(state => state.favourites)
  const addFavourite = useStore(state => state.addFavourite)
  const removeFavourite = useStore(state => state.removeFavourite)
  // let activeApt = useStore(state => state.activeApt)
  const kView = useStore(state => state.kView)
  const setKView = useStore(state => state.setKView)

  const show360 = useStore(state => state.show360)
  const setShow360 = useStore(state => state.setShow360)

  const setShowRecipient360 = useStore(state => state.setShowRecipient360)
  let floor = useApartmentFloorLevelByPlotNumber()[id]

  let flatType = useApartmentTypeByPlotNumber()[id]
  let activeBlock = useBlockIDbyPlotNumber()[id]
  let blockByID = activeBlock?.split(".")[0].charAt(0)
  let fullBlockName = activeBlock?.split(".")[0]

  if (data) {
    flatType = data["FlatType"]
    activeBlock = data["PlotNumberPlanning"]
    blockByID = activeBlock?.split(".")[0]
    floor = data["FloorLevel"]
  }

  const socket = useRef()
  const zoomViewer = useRef()

  const [zoom, setZoom] = useState(1)
  const [x, setX] = useState(0)
  const [y, setY] = useState(0)

  useEffect(() => {
    setShow360(false)
    setShowRecipient360(false)
    setTimeout(() => {
      setVisible(true)
    }, 10)

    socket.current = io(url)
    if (role === "recipient") {
      socket.current.on("favcard", data => {
        if (data) {
          zoomViewer?.current?.setTransform(data.x, data.y, data.zoom)
        }
      })
    }
    return () => setFullScreenPlan(false)
  }, [])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("favcard", { zoom: zoom, x: x, y: y })
    }
  }, [zoom, x, y])

  const thisID = activeBlock?.split(".")[1] + "." + activeBlock?.split(".")[2]

  const handleSwitchViews = () => {
    if (kView === "a") {
      setKView("b")
    } else {
      setKView("a")
    }
  }

  const key = activeApt

  return (
    <FavouriteCardContainer visible={visible ? 1 : 0}>
      <FloorplanHolder>
        <TransformWrapper
          ref={zoomViewer}
          onZoom={event => {
            setZoom(event.state.scale)
            setX(event.state.positionX)
            setY(event.state.positionY)
          }}
          onPanning={event => {
            setZoom(event.state.scale)
            setX(event.state.positionX)
            setY(event.state.positionY)
          }}
          onPinching={event => {
            setZoom(event.state.scale)
            setX(event.state.positionX)
            setY(event.state.positionY)
          }}
        >
          <TransformComponent
            wrapperStyle={{ width: "100%", height: "100%" }}
            contentStyle={{ width: "100%", height: "100%" }}
          >
            <img
              src={
                blockByID === "H"
                  ? `assets/apartmentfinder/images/floorplans/H/${id}.svg.svg`
                  : blockByID === "J"
                  ? `assets/apartmentfinder/images/floorplans/${blockByID}_${id}.svg`
                  : blockByID === "E" || blockByID === "K"
                  ? `assets/apartmentfinder/images/floorplans/${blockByID}_${flatType}.png`
                  : `assets/apartmentfinder/images/floorplans/${activeApt.replaceAll(".", "_")}${
                      blockByID === "F" ? ".svg" : ".png"
                    }`
              }
              alt={id}
              style={{
                padding: blockByID === "J" || blockByID === "F" || blockByID === "H" ? "10%" : "0",
                width: "100%",
                height: "100%",
                objectFit: "contain"
              }}
            />
          </TransformComponent>
        </TransformWrapper>
      </FloorplanHolder>
      <InfoHolder>
        {!data && (
          <BookmarkHolder
            onClick={favourites.includes(id) ? () => removeFavourite(id) : () => addFavourite(id)}
          >
            <FavouriteBookmark includes={favourites.includes(id)} />
          </BookmarkHolder>
        )}
        <TitleHolder>
          <Level>{zeroPad(floor, 2)}</Level>
          <ApartID>{activeBlock}</ApartID>
        </TitleHolder>
        <InfoContent>
          <BlockID>{buildingNames[fullBlockName]}</BlockID>
          {blockByID === "H" ? (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "grid",
                gridTemplateRows: "repeat(7, minmax(0, 1fr))",
                placeItems: "center start",
                gridAutoFlow: "row",
                rowGap: "4px",
                color: "white",
                fontWeight: 200,
                fontFamily: "NotoSans-Regular"
              }}
            >
              {Object.keys(dimsdata[key]).map(title => {
                return (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "grid",
                      placeItems: "start",
                      gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
                      fontSize: "14px"
                    }}
                  >
                    <p>{title}</p>
                    <p
                      style={{
                        placeSelf: "center end",
                        color: "white"
                      }}
                    >
                      {dimsdata[key][title]}
                    </p>
                  </div>
                )
              })}
            </div>
          ) : blockByID === "J" ? (
            <Dimensions
              image={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/jdims/${id}.png`}
            />
          ) : (
            <Dimensions
              image={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/dimensions/${activeBlock}.svg`}
            />
          )}
        </InfoContent>
        <Content>
          <Compas image={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/compass.png`} />
          <ElevationHolder>
            <StaticElevationSvgJsx
              activeBlock={blockByID}
              forCard={true}
              isCard={true}
              floor={zeroPad(floor, 2)}
            />
          </ElevationHolder>
        </Content>
        <ButtonHolder>
          {!data && (
            <ResponsiveButton
              activeBlock={activeBlock}
              isMultiView={isMultiView}
              setViewID={setViewID}
              setShow360={setShow360}
            />
          )}
        </ButtonHolder>
      </InfoHolder>
      {show360 && (
        <ThreeSixtyWrapper>
          {activeBlock.split(".")[0].charAt(0) === "K" ? (
            <>
              <img
                onClick={() => setShow360(false)}
                style={{
                  zIndex: 999,
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
                src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/views/360/K/K_${thisID}_${kView}.jpg`}
                alt="K"
              ></img>
              <img
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "100%",
                  padding: "10px",
                  bottom: "2%",
                  left: "50%",
                  zIndex: 999,
                  position: "absolute",
                  transform: `translate(-50%, 0) ${
                    kView === "a" ? "rotate(0deg)" : "rotate(180deg)"
                  } `,
                  transition: "transform  0.6s ease;",
                  cursor: "pointer",
                  objectFit: "cover",
                  backgroundColor: "#657B73"
                }}
                onClick={() => handleSwitchViews()}
                src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon.svg`}
                alt="<"
              ></img>
            </>
          ) : (
            <Viewer360
              id={id}
              viewID={viewID}
              activeBlock={activeBlock}
              block={activeBlock.charAt(0)}
              floor={floor}
              setShow={setShow360}
              activeApt={activeApt}
            />
          )}
        </ThreeSixtyWrapper>
      )}
    </FavouriteCardContainer>
  )
}

const ResponsiveButton = ({ setShow360, isMultiView, setViewID, activeBlock }) => {
  console.log("activeBlock", activeBlock)
  // if (activeBlock.includes("J1")) {
  //   return <p style={{ color: "white" }}>View coming soon</p>
  // }
  if (isMultiView) {
    return (
      <MultiView
        isBlockH={activeBlock.includes("H")}
        setViewID={setViewID}
        setShow360={setShow360}
      />
    )
  } else {
    return <SingleView activeBlock setShow360={setShow360} />
  }
}

function MultiView({ setShow360, setViewID, isBlockH }) {
  const [down, setDown] = useState(false)
  return (
    <>
      <Button
        style={{ height: "100%" }}
        onPointerDown={() => setDown(true)}
        onPointerUp={() => setDown(false)}
        onClick={() => {
          setViewID(isBlockH ? "courtyard" : "north")
          setShow360("north")
        }}
        down={down}
        color={"#536866"}
      >
        {isBlockH ? "COURTYARD VIEW" : "NORTH VIEW"}
      </Button>
      <Button
        style={{ height: "100%", borderLeft: "#ccc solid 2px" }}
        onPointerDown={() => setDown(true)}
        onPointerUp={() => setDown(false)}
        onClick={() => {
          setViewID("south")
          setShow360("south")
        }}
        down={down}
        color={"#536866"}
      >
        {isBlockH ? "STREET VIEW" : "SOUTH VIEW"}
      </Button>
    </>
  )
}

function SingleView({ setShow360 }) {
  const [down, setDown] = useState(false)
  return (
    <Button
      style={{ height: "100%" }}
      onPointerDown={() => setDown(true)}
      onPointerUp={() => setDown(false)}
      onClick={() => setShow360(true)}
      down={down}
      color={"#536866"}
    >
      View
    </Button>
  )
}
